import { Box, Paper, Stack } from "@mui/material";
import brandLogo from "assets/images/logos/logo-publique.png";
export default function VerificationFrame({ children }) {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        bgcolor: "#f4f8f5",
        display: "grid",
        placeItems: "center",
        p: { xs: 2, sm: 4 },
      }}
    >
      <Stack alignItems="center" spacing={3} sx={{ width: "100%", maxWidth: 540 }}>
        <Box
          component="img"
          src={brandLogo}
          alt="Publique Sua Obra"
          sx={{ width: 85, height: 112, objectFit: "contain" }}
        />
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            p: { xs: 3, sm: 4 },
            border: "1px solid #dfe9e2",
            borderRadius: 4,
            "& .MuiButton-root": { minHeight: 46, borderRadius: 2, boxShadow: "none" },
          }}
        >
          {children}
        </Paper>
      </Stack>
    </Box>
  );
}
export function verificationError(error) {
  if (["auth/expired-action-code", "auth/invalid-action-code"].includes(error?.code))
    return "Este link expirou ou já foi utilizado. Entre na sua conta para conferir o status e solicitar um novo e-mail, se necessário.";
  if (error?.code === "auth/too-many-requests")
    return "Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.";
  if (["auth/unauthorized-continue-uri", "auth/invalid-continue-uri"].includes(error?.code))
    return "O domínio de confirmação precisa ser autorizado no Firebase. Entre em contato com a equipe PSO.";
  if (error?.code === "auth/network-request-failed")
    return "Não foi possível conectar. Confira sua internet e tente novamente.";
  return error?.code
    ? "Não foi possível concluir a verificação. Tente novamente em instantes."
    : error?.message || "Não foi possível verificar sua conta.";
}
